import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { DicomMetadataStore } from '@ohif/core';
import Dropzone from 'react-dropzone';
import filesToStudies from './filesToStudies';
import { Button, LoadingIndicatorProgress } from '@ohif/ui';

//console.log('platform/viewer/src/routes/Local/Local.tsx');

const getLoadButton = (onDrop, text, isDir) => {
  if (isDir === undefined) {
    return (
      <div>
        <Button
          rounded="full"
          variant="contained" //"outlined" // contained
          disabled={false}
          // endIcon={<Icon name="launch-arrow" />} // launch-arrow | launch-info
          className={classnames('font-medium', 'ml-2')}
          onClick={onDrop}
        >
          {text}
        </Button>
      </div>
    );
  } else {
    return (
      <Dropzone onDrop={onDrop} noDrag>
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()}>
            <Button
              rounded="full"
              variant="contained" //"outlined" // contained
              disabled={false}
              // endIcon={<Icon name="launch-arrow" />} // launch-arrow | launch-info
              className={classnames('font-medium', 'ml-2')}
              onClick={() => {}}
            >
              {text}
              {isDir ? (
                <input
                  {...getInputProps()}
                  webkitdirectory="true"
                  mozdirectory="true"
                />
              ) : (
                <input {...getInputProps()} />
              )}
            </Button>
          </div>
        )}
      </Dropzone>
    );
  }
};

function Local(props) {
  const { servicesManager } = props;
  const { uiNotificationService, uiModalService } = servicesManager.services;

  const navigate = useNavigate();
  const dropzoneRef = useRef();
  const [dropInitiated, setDropInitiated] = React.useState(false);
  const versionNumber = process.env.VERSION_NUMBER;

  function tooMany() {
    return (
      <div className="flex justify-center items-center">
        <p>
          Your data contains too many files, maximum number of files in one pass
          is 1500.
        </p>
      </div>
    );
  }

  function showTooMany() {
    uiModalService.show({
      content: tooMany,
      title: 'Too many files',
    });
  }

  function notFound() {
    return (
      <div className="flex justify-center items-center">
        <p>Couldn't find enough usable DICOM images</p>
      </div>
    );
  }

  function showNotFound() {
    uiModalService.show({
      content: notFound,
      title: 'Found no images',
    });
  }

  function inferNotPossible(reason) {
    return (
      <div>
        <div className="flex justify-center items-center">
          <p>
            Analysis not possible on the given data, however you still can view
            the images in the viewer.
          </p>
        </div>
        <div className="flex justify-center items-center">
          <p>Problem(s):</p>
        </div>

        <div className="flex justify-center items-center">
          <p>{reason}</p>
        </div>
      </div>
    );
  }

  function showInferNotPossible(reason) {
    function inp() {
      return inferNotPossible(reason);
    }
    uiModalService.show({
      content: inp,
      title: 'Analysis not possible',
    });
  }

  function unreliable(reason) {
    return (
      <div>
        <div className="flex justify-center items-center">
          <p>
            The given data is non standard DICOM. Analisys still possible, but
            results might be unreliable.
          </p>
        </div>
        <div className="flex justify-center items-center">
          <p>Problem(s):</p>
        </div>

        <div className="flex justify-center items-center">
          <p>{reason}</p>
        </div>
      </div>
    );
  }

  function showUnreliable(reason) {
    function inp() {
      return unreliable(reason);
    }
    uiModalService.show({
      content: inp,
      title: 'Non standard DICOM',
    });
  }

  function notMR() {
    return (
      <div className="flex justify-center items-center">
        <p>No/not enough MR images found in your data</p>
      </div>
    );
  }

  function showNotMR() {
    uiModalService.show({
      content: notMR,
      title: 'Not MR',
    });
  }

  function tooManyStudies() {
    return (
      <div className="flex justify-center items-center">
        <p>Your data contains more than one study, please open only one!</p>
      </div>
    );
  }

  function showTooManyStudies() {
    uiModalService.show({
      content: tooManyStudies,
      title: 'Not a single study',
    });
  }

  function tooBig() {
    return (
      <div className="flex justify-center items-center">
        <p>Overall file size is over 150 MB, expect slower loading!</p>
      </div>
    );
  }

  function showTooBig() {
    uiModalService.show({
      content: tooBig,
      title: 'Big file',
    });
  }

  function huge() {
    return (
      <div className="flex justify-center items-center">
        <p>Overall file size is over 1 GB, impossible to load!</p>
      </div>
    );
  }

  function showHuge() {
    uiModalService.show({
      content: huge,
      title: 'Huge file',
    });
  }

  // function showError(message) {
  //   uiNotificationService.show({
  //     title: 'Error ',
  //     message: message,
  //     type: 'warning',
  //     duration: 16000,
  //   });
  // }

  const openViewer = async () => {
    console.log('open archive viewer');
    navigate('/worklist');
  };

  function checkFiles(files) {
    var summSize = 0;

    for (let file of files) {
      summSize += file.size;
    }

    if (summSize > 1024 * 1024 * 1024) {
      showHuge();
      console.log(
        ' file size is ',
        summSize / 1024 / 1024 / 1024,
        'GB, not loading'
      );
      return 0;
    } else if (summSize > 150 * 1024 * 1024) {
      showTooBig();
    }
    return 1;
  }

  const onDrop = async acceptedFiles => {
    if (acceptedFiles.length < 1501) {
      setDropInitiated(true);

      if (checkFiles(acceptedFiles) == 1) {
        const result = await filesToStudies(acceptedFiles);

        const studies = result[0];
        const foundMR = result[1];
        // console.log('studies', studies);
        // console.log('found MR', foundMR);

        if (studies.length == 1) {
          const query = new URLSearchParams();
          // studies.forEach(id => query.append('StudyInstanceUIDs', id));

          var id = studies[0];
          const study = DicomMetadataStore.getStudy(id);

          query.append('StudyInstanceUIDs', id);

          if (!study.inferable) {
            console.log('study not inferable, problems:', study.problems);
            showInferNotPossible(study.problems);
          } else {
            if (study.problems.length !== 0) {
              showUnreliable(study.problems);
            }
          }
          navigate(
            `/viewer/dicomlocal?${decodeURIComponent(query.toString())}`
          );
        } else {
          console.log(
            'more than one, or no study (',
            studies.length,
            ') , not loading'
          );
          setDropInitiated(false);
          if (!foundMR) {
            showNotFound();
          } else {
            if (studies.length > 1) {
              showTooManyStudies();
            } else {
              showNotMR();
            }
          }
          console.log("couldn't find enough usable data");
        }
      }
      setDropInitiated(false);
    } else {
      showTooMany();
      console.log('too many files dropped: ', acceptedFiles.length);
    }
  };

  // Set body style
  useEffect(() => {
    document.body.classList.add('bg-black');
    return () => {
      document.body.classList.remove('bg-black');
    };
  }, []);

  return (
    <Dropzone
      ref={dropzoneRef}
      onDrop={acceptedFiles => {
        setDropInitiated(true);
        onDrop(acceptedFiles);
      }}
      noClick
    >
      {({ getRootProps }) => (
        <div {...getRootProps()} style={{ width: '100%', height: '100%' }}>
          <div className="h-screen w-screen flex justify-center items-center ">
            <div className="bg-[url(/blank.png)] drop-shadow-md space-y-2 rounded-lg w-[512px] h-[512px]">
              <div className="text-center space-y-2 pt-4">
                {dropInitiated ? (
                  <div className="pt-[350px] pb-[24px]">
                    <LoadingIndicatorProgress
                      textBlock={
                        <span className="text-blue-300 text-lg">
                          Loading files, please wait ...
                        </span>
                      }
                      indicatorStyle={{ width: '24em' }}
                    />
                  </div>
                ) : (
                  <div className="space-y-2">
                    {/* pl : pad left */}
                    <p className="text-lg text-gray-300  pt-[180px] pl-[290px]">
                      version: {versionNumber}
                    </p>

                    {/* pt : pad top */}
                    <p className="text-xg text-blue-300 font-semibold pt-[160px]">
                      Drag and Drop your DICOM files here
                    </p>

                    <p className="text-blue-300 text-lg font-semibold pt-[10px]">
                      Or click to
                    </p>
                  </div>
                )}
              </div>
              <div className="flex justify-around pt-2 ">
                {getLoadButton(onDrop, 'Load files', false)}
                {getLoadButton(onDrop, 'Load folders', true)}
                {getLoadButton(openViewer, 'Open archive', undefined)}
              </div>
              <div className="text-center space-y-2 px-8">
                {/*  <p className="text-blue-300 text-base">
                        Note: Your data is not uploaded to any server yet, it will stay
                        in your local browser application for the moment
                </p> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </Dropzone>
  );
}

export default Local;
